import { render, staticRenderFns } from "./view.html?vue&type=template&id=32410aee&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=32410aee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32410aee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32410aee')) {
      api.createRecord('32410aee', component.options)
    } else {
      api.reload('32410aee', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=32410aee&scoped=true&", function () {
      api.rerender('32410aee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/award3/index.vue"
export default component.exports